export const THUMBNAIL_DIMENSIONS = 140;
export const THUMBNAIL_DIMENSIONS_V2 = 115;
export const GROUP_ITEM_DIMENSIONS = 115;
export const LIST_ITEM_HEIGHT = 8 * 4 + THUMBNAIL_DIMENSIONS;
export const LIST_GROUP_ITEM_HEIGHT = 8 * 3 + GROUP_ITEM_DIMENSIONS;

export const CARD_LAYOUT_STYLES = {
  display: 'grid',
  gridTemplateColumns: 'auto auto 1fr auto',
  gridTemplateRows: 'auto 1fr auto',
  gridTemplateAreas: `
    "control thumb title action"
    "control thumb content content"
    "control thumb view view"
  `,
  gap: theme => `${theme.spacing(0.5)} 0`,
};
